import globalErrorMiddleware from './src/middleware';

export const middleware = globalErrorMiddleware;
export * as errorTypes from './src/constants';
